module.exports = __webpack_public_path__ + "8cfd4618a2d4f9dd8b7ddfed18c7b227.jpg";